import { mapEnvTypes } from "./mapEnvTypes";

export const baseScale = 10;
export const tileSize = 1;
const scaledTileSize = tileSize * baseScale;
  
// Function to render the MUD map
export function renderMap2(
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  mudMap: any,
  _areaId: number,
  _level: number,
  _selectedRoomId: number) {

  const paths: any = {};
  
  if (!mudMap) return;

  //ctx.clearRect(0, 0, canvas.width, canvas.height);

  const area = mudMap.areasById[_areaId];
  const rooms = area.levelsById[_level].rooms;
  for (let room of rooms) {
    const x = room.coordinates[0] * baseScale;
    const y = room.coordinates[1] * baseScale;

    for (let exit of room.exits) {
      const exitRoom = mudMap.roomsById[exit.exitId];
      if (exitRoom && exit.name !== 'up' && exit.name !== 'down') {
        const x1 = x;
        const y1 = y;
        const x2 = exitRoom.coordinates[0] * baseScale;
        const y2 = exitRoom.coordinates[1] * baseScale;

        if (exitRoom.areaId === _areaId) {
          let pathKey: string;
          if (room.id < exitRoom.id) {
            pathKey = room.id + '|' + exitRoom.id;
          } else {
            pathKey = exitRoom.id + '|' + room.id;
          }

          if (!paths[pathKey]) {
            if (exitRoom.exits.some((x: any) => x.exitId === room.id)) {
              ctx.beginPath();
              ctx.strokeStyle = "#cccccc";
              ctx.moveTo(x1, y1);
              ctx.lineTo(x2, y2);
              ctx.stroke();
            } else {
              ctx.beginPath();
              ctx.setLineDash([2, 3]);
              ctx.strokeStyle = "#cccccc";
              ctx.moveTo(x1, y1);
              ctx.lineTo(x2, y2);
              ctx.stroke();
              ctx.setLineDash([]);
            }
            paths[pathKey] = true;
          }

        } else {
          switch (exit.name) {
            case 'west':
              ctx.beginPath();
              ctx.strokeStyle = "#ff0000";
              ctx.moveTo(x1 - baseScale * 1.5, y1);
              ctx.lineTo(x1, y1);
              ctx.stroke();
              break;
            case 'east':
              ctx.beginPath();
              ctx.strokeStyle = "#ff0000";
              ctx.moveTo(x1 + baseScale * 1.5, y1);
              ctx.lineTo(x1, y1);
              ctx.stroke();
              break;  
            case 'north':
              ctx.beginPath();
              ctx.strokeStyle = "#ff0000";
              ctx.moveTo(x1, y1 - baseScale * 1.5);
              ctx.lineTo(x1, y1);
              ctx.stroke();
              break;  
            case 'south':
              ctx.beginPath();
              ctx.strokeStyle = "#ff0000";
              ctx.moveTo(x1, y1 + baseScale * 1.5);
              ctx.lineTo(x1, y1);
              ctx.stroke();
              break;  
          }
        }
      }
    }
  }
  

  for (let room of rooms) {
    const x = room.coordinates[0] * baseScale;
    const y = room.coordinates[1] * baseScale;

    if (room.id === _selectedRoomId) {
      const fillColor = mapEnvTypes[room.environment].color || '#cc0000';
        ctx.beginPath();
        ctx.rect(x - scaledTileSize / 2, y - scaledTileSize / 2, scaledTileSize, scaledTileSize);
        ctx.strokeStyle = "#cccccc";
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(x,y,scaledTileSize, 0, Math.PI*2);
        ctx.strokeStyle = "#ff0000";
        ctx.fillStyle = "#cc000077";
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.arc(x,y,scaledTileSize*1.25, 0, Math.PI*2);
        ctx.strokeStyle = "#ff0000";
        ctx.stroke();

      } else {
        const fillColor = mapEnvTypes[room.environment].color || '#cc0000';
        ctx.beginPath();
        ctx.rect(x - scaledTileSize / 2, y - scaledTileSize / 2, scaledTileSize, scaledTileSize);
        ctx.strokeStyle = "#cccccc";
        ctx.fillStyle = fillColor;
        ctx.fill();
        ctx.stroke();
      }
  }


  //labels          
  const labels = area.labels.filter((x: any) => x.coordinates[2] === _level);
  for (let label of labels) {
    const x = label.coordinates[0] * baseScale;
    const y = label.coordinates[1] * baseScale;
    const w = label.size[0] * baseScale * .9;
    const h = label.size[1] * baseScale * .9;
    ctx.drawImage(label.htmlImage, x, y, w, h);
  }
}



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////









































